"use client";
import { styled } from "@mui/material/styles";
import { ColorGray900, ColorGray700 } from "@nxt-costco-com/forge-design-tokens";
import { Pause, Play } from "@nxt-costco-com/forge-icons";
const BUTTON_SIZE = 20;
const StyledPause = styled(Pause)(() => ({
  color: ColorGray700,
  cursor: "pointer",
  height: BUTTON_SIZE,
  width: BUTTON_SIZE,
  "&:hover": {
    color: ColorGray900
  }
}));
const StyledPlay = styled(Play)(() => ({
  color: ColorGray700,
  cursor: "pointer",
  height: BUTTON_SIZE,
  width: BUTTON_SIZE,
  "&:hover": {
    color: ColorGray900
  }
}));
export {
  StyledPause,
  StyledPlay
};
